<template>
	<div class="customer-list-wrapper">
    <div class="row d-flex align-items-center">
      <div class="col-md-4">
        <h4>Admins List</h4>
      </div>
      <div class="col-md-3 text-right">
      </div>
      <div class="col-md-5">
        <div class="d-flex justify-content-end">
          <input v-model="searchQuery" type="text" style="min-width: 200px" class="form-control mt-10 mr-3" placeholder="Search in Admin List" />
          <button v-if="user.userType === 'super-admin'" @click="openModal({type: 'add'})" class="btn btn-primary">Add New Admin</button>
          <button v-if="user.userType === 'super-admin'" @click="exportShifts()" class="btn btn-primary">Export Shifts</button>
        </div>
      </div>
    </div>
		<div class="customer-list-info">
			<div class="loader" v-if="loader"></div>
      <p class="card-text text-center text-danger mb-3 font-weight-bold" v-else-if="!loader && customers.length === 0">There are no admins in the database to show here. Please create some admins in order for them to show up here.</p>
    </div>
		<div class="customer-table" v-if="customers.length > 0 && !loader">
			<table id="datatable" class="table table-striped table-bordered" cellspacing="0" width="100%">
				<thead>
				<tr>
          <th>HB ID</th>
					<th>Name</th>
					<th>Email</th>
					<th>Role</th>
          <th>Department</th>
<!--					<th>HB Full Name</th>-->
<!--					<th>HB Tag Names</th>-->
          <th>Two FA</th>
					<th>Created</th>
					<th class="disabled-sorting">Actions</th>
				</tr>
				</thead>
				<tfoot>
				<tr>
          <th>HB ID</th>
					<th>Name</th>
					<th>Email</th>
					<th>Role</th>
          <th>Department</th>
<!--          <th>HB Full Name</th>-->
<!--          <th>HB Tag Names</th>-->
          <th>Two FA</th>
          <th>Created</th>
					<th class="disabled-sorting">Actions</th>
				</tr>
				</tfoot>
				<tbody>
				<tr v-for="(customer, index) in filterAdmins" :key="index">
          <td>{{ customer.hbID }}</td>
					<td>{{ customer.firstName }} {{ customer.lastName }}</td>
          <td>
            <div class="d-flex align-items-center">
              <div class="photo">
                <img width="20px" class="rounded-circle mr-4" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(customer.email)}?s=50`">
              </div>
              <span class="ml-9">{{ customer.email }}</span>
              <i v-if="showIcon(customer)" @mouseover="getTitle(customer, index, true)" @mouseleave="getTitle(customer, index, true)" :id="'info'+index" class="text-danger fa fa-info-circle ml-5 make-cursor-pointer"></i>
            </div>
          </td>
          <td class="text-transform"> {{customer.userType}}
          <td>
            <select name="userType" v-model="customer.department" @change="updateUserDepartment(customer)" class="form-control">
              <option value="sales">Sales</option>
              <option value="support">Support</option>
              <option value="development">Development</option>
            </select>
          </td>
<!--          <td>{{ customer.hbName }}</td>-->
<!--          <td width="20%">-->
<!--            <template v-if="showTagInput && index == selectedIndex">-->
<!--              <div class="d-flex">-->
<!--                <multi-select-->
<!--                    type="text"-->
<!--                    v-model="adminTags"-->
<!--                    tag-placeholder="Add tag"-->
<!--                    placeholder="Add tags"-->
<!--                    :options="adminTags"-->
<!--                    :option-height="3"-->
<!--                    :multiple="true"-->
<!--                    :taggable="true"-->
<!--                    @tag="addTags"-->
<!--                    openDirection="bottom"-->
<!--                >-->
<!--                  <template slot="singleLabel" slot-scope="{ adminTags, remove }">-->
<!--                    <input-->
<!--                        type="text"-->
<!--                        v-model="adminTags"-->
<!--                    >-->
<!--                    <span @click="remove(adminTags)">&times;</span>-->
<!--                  </template>-->
<!--                  <span slot="noOptions">No tag available.</span>-->
<!--                </multi-select>-->
<!--                <span><i @click="saveTags(customer, index)" title="Save" class="fa fa-save text-primary ml-10 make-cursor-pointer"></i><i title="Cancel" @click="hideInput" class="fa fa-ban text-danger ml-10 make-cursor-pointer"></i></span>-->
<!--              </div>-->

<!--            </template>-->
<!--            <template v-else>-->
<!--              <span v-if="customer.hbTags && customer.hbTags.length > 0">{{ customer.hbTags.join(', ')}}</span>-->
<!--              <span @click="showInput(index, customer.hbTags)" class="text-center"><i title="Edit Tags" class="fa fa-pencil ml-20 text-success make-cursor-pointer"></i></span>-->
<!--            </template>-->
<!--          </td>-->
          <td class="sort-date">{{ customer.twoFAVerified ? 'Enabled' : 'Disabled' }}</td>
					<td class="sort-date">{{ formattedDate(customer.createdAt) }}</td>
					<td class="text-center">
						<button  v-if="user.userType === 'super-admin'" @click="openModal({...customer, type: 'edit'})" type="button" class="btn text-light btn-link bg-info btn-sm pull-left mr-2" :data="customer.docID">
							<i class="fa fa-pencil"></i>
						</button>
            <button v-if="user.userType === 'super-admin'" @click="deleteUser(customer.docID)" type="button" class="btn text-light btn-link bg-danger btn-sm remove pull-left mr-2" :data="customer.docID">
							<i class="fa fa-times"></i>
						</button>
            <button type="button" class="btn text-light btn-link bg-primary btn-sm pull-left" data-toggle="modal"  @click="fixModal(customer)" data-target="#newAttendanceModal">
              <i class="fa fa-clock-o" aria-hidden="true"></i>
            </button>
					</td>
				</tr>
				</tbody>
			</table>
      <attendance-modal  ref="attendanceRef"  />
		</div>
    <create-admin @refreshAdmin="refreshAdmin" ref="createModal" />
  </div>
</template>


<script>
	import {db, functions} from "@/firebase/init";
	import refreshToken from "../../../../mixins/refreshTokenMixin";
	import loginAsMixin from "../../../../mixins/loginAsMixin";
	import adminLogs from "../../../../mixins/adminLogs";
	import dateMixin from "../../../../mixins/dateMixin";
  import multiSelect from "vue-multiselect";
  import AttendanceModal from './AttendanceModal.vue'
  import CreateAdmin from './../../../../views/admin/CreateAdmin/CreateAdmin.vue'
  import CreateAdminUser from "@/views/admin/CreateAdmin/CreateAdmin";
  import md5 from "crypto-js/md5";
  import tippy from "tippy.js";
  import 'tippy.js/dist/tippy.css';
	export default {
		name: "CreatedUserList",
		mixins: [loginAsMixin, refreshToken, adminLogs, dateMixin],
    components: {CreateAdminUser, multiSelect, AttendanceModal,CreateAdmin},
		data() {
			return {
        exportShiftLoader: false,
        allShifts: [],
        loader:false,
				customers: [],
				noUser: false,
        showTagInput: false,
        selectedIndex: -1,
        adminTags: [],
        selectedUser: {},
        searchQuery: ''
			};
		},
		computed: {
      filterAdmins () {
        return this.sortAdmins.filter(el => (el.email.toLowerCase().includes(this.searchQuery.toLowerCase()) || el.firstName.toLowerCase().includes(this.searchQuery.toLowerCase()) || el.lastName.toLowerCase().includes(this.searchQuery.toLowerCase()) || el.userType.toLowerCase().includes(this.searchQuery.toLowerCase()) ))
      },
      sortAdmins() {
        return this.customers.sort(function(a, b){
          if(a.firstName.toLowerCase() < b.firstName.toLowerCase()) { return -1; }
          if(a.firstName.toLowerCase() > b.firstName.toLowerCase()) { return 1; }
          return 0;
        })
      },
			asyncDone() {
				return this.$store.getters["async/state"];
			},
			user() {
				return this.$store.getters.user;
			},
			userToken() {
				return this.$store.getters.getUserToken;
			},
			plans() {
				return this.$store.getters["plan/list"];
			}
		},
		methods: {
      async exportShifts(){
        this.exportShiftLoader = true;

        const data = this.allShifts.map(el => {
          const obj = {
            email: el.email, shifts: []
          }
          if(el.shifts) {
            Object.keys(el.shifts).forEach(key => {
              obj.shifts.push({day: key, shiftIn: el.shifts[key].shiftIn, shiftOut: el.shifts[key].shiftOut})
            })
          }
          return obj
        })
        const jsonString = JSON.stringify(data, null, 2); // pretty format
        const blob = new Blob([jsonString], { type: "application/json" });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "shifts.json"; // file name
        a.click();

        URL.revokeObjectURL(url);
      },
      showIcon(row){
        const obj = this.allShifts.find(el => el && el.email === row.email);
        const obj2 = obj && obj.shifts ? !!Object.values(obj.shifts).find(el => el.shiftIn && !el.shiftOut) || !!Object.values(obj.shifts).every(el => !el.shiftIn && !el.shiftOut) : false
        return obj2
      },
      async getTitle(row, index, flag){
        // if(!flag) {
        //   return true
        // }
        const obj = this.allShifts.find(el => el && el.email === row.email);
        const obj2 = obj && obj.shifts ? !!Object.values(obj.shifts).find(el => el.shiftIn && !el.shiftOut) || !!Object.values(obj.shifts).every(el => !el.shiftIn && !el.shiftOut) : false
        if(obj2 && flag) {
          tippy(`#info${index}`, {
            content: obj2 ? 'Please add missing shiftin/shiftout time.' : '',
            allowHTML: true,
            theme: 'dark', // Customize the theme in your CSS if needed
            placement: 'top'
          });
        }
        return obj2
      },
      emailHashGravatar(email) {
        if (!email) {
          return null
        } else {
          return md5(email.trim().toLowerCase()).toString()
        }
      },
      fixModal(customer){
        this.$refs.attendanceRef.openModal(customer)
      },
      openModal(data) {
        if(data.type === 'edit') {
          this.$refs.createModal.load(data)
        } else {
          this.$refs.createModal.load(data)
        }
      },
      async updateUserDepartment(user){
        if (confirm("Are you sure you want to change the user department?")){
          try{
            await db.collection('users').doc(user.docID).update({ department: user.department })
          }catch(e){
            console.log('Could not update user department', e.toString())
          }
        }
      },
      async saveTags(admin, index) {
        console.log(admin, this.adminTags)
        try {
          await this.$store.dispatch("async/stateUpdate", {state: true});
          this.selectedIndex = index;
          await db.collection('users').doc(admin.docID).update({ hbTags: this.adminTags })
          await this.getAdmins();
          this.selectedIndex = -1;
          this.showTagInput = false;
          await this.$store.dispatch("async/stateUpdate", {state: false});
        } catch (e) {
          console.log(e.toString())
        }
      },
      showInput(index, tags = []) {
        this.showTagInput = true; this.selectedIndex = index;
        this.adminTags = tags;
      },
      hideInput(){
        this.showTagInput = false; this.selectedIndex = -1; this.adminTags = [];
      },
      addTags (newID){
        this.adminTags.push(newID);
      },
      refreshAdmin(data) {
        if(data.success) {
          this.$store.dispatch("alert/update", {
            type: "success",
            message: data.msg,
            show: true
          });
          this.loader=true
          this.getAdmins()
          setTimeout(() => {
            this.$store.dispatch("alert/showUpdate", {show: false});
          }, 5000);
        } else {
          this.$store.dispatch("alert/update", {
            type: "danger",
            message: data.msg,
            show: true
          });
        }
        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", {show: false});
        }, 5000);
      },
			getAdmins(alertDetails) {
        this.loader=true
        this.customers = [];
        this.getUsersByType("admin", alertDetails, true)
      },
			getUsersByType(type, alertDetails, statusLoading = false) {
        return db.collection("users")
					.where("userType", "in", ['admin', 'manager', 'super-admin'])
            .get()
					.then(snapshot => {
						if (snapshot.empty === true) {
							this.noUser = true;
						}

						snapshot.forEach(doc => {
							this.customers.push({
								docID: doc.id,
								...doc.data()
							});
						});

						// If alertDetails variable passed then show alert with the passed details
						if (alertDetails) {
							// Show success message to the user for 5 sec
							this.$store.dispatch("alert/update", {
								...alertDetails
							});
							setTimeout(() => {
								this.$store.dispatch("alert/showUpdate", {show: false});
							}, 5000);
						}
					})
					.catch(err => {
            console.log('255',err.toString())
						// Show error message to the customer for 5 sec
						this.$store.dispatch("alert/update", {
							type: "danger",
							message: err.name,
							show: true
						});

						setTimeout(() => {
							this.$store.dispatch("alert/showUpdate", {show: false});
						}, 5000);
					})
					.finally(() => {
						if(statusLoading){
							this.$store.dispatch("async/stateUpdate", {state: true});
						}
            this.loader = false
          });
			},
			updateUser(customer){
				if (
					confirm(
						"Are you sure you want to change the user role?"
					)
				) {
					// Set asyncDone to false
					this.$store.dispatch("async/stateUpdate", {state: false});

					// Connect with firebase cloud functions and pass the docID as a data parameter to delete the user from the system
					db.collection("users")
						.doc(customer.docID)
						.update({
							userType: customer.userType
						})
						.then(result => {
							this.$store.dispatch("async/stateUpdate", {state: false});

							this.getAdmins({
								type: "success",
								message:
									"The user role has successfully been updated from the system.",
								show: true
							});
              this.addLog({
                message: "The user role has successfully been updated from the system.",
                level: "info"
              })
							this.$store.dispatch("async/stateUpdate", {state: true});
						})
						.catch(err => {
							// Show error message to the user for 5 sec
							this.$store.dispatch("alert/update", {
								type: "danger",
								message: err,
								show: true
							});
              this.addLog({
                message: err,
                level: "danger"
              })
							setTimeout(() => {
								this.$store.dispatch("alert/showUpdate", {show: false});
							}, 5000);
						});
				}
			},
			deleteUser(docID) {
				if (
					confirm(
						"Are you certain that you want to delete this user? This process cannot be undone."
					)
				) {
					// Set asyncDone to false
					this.$store.dispatch("async/stateUpdate", {state: false});

					// Connect with firebase cloud functions and pass the docID as a data parameter to delete the user from the system
					// const deleteUser = functions.httpsCallable("deleteUser");
					// deleteUser({
					// 	uid: docID
					// })

          this.$http.post('user/delete-user', {
            grant_type: 'token',
            uid: docID
          })
            .then(result => {
              if (result.data.message === "success") {

                this.$store.dispatch("async/stateUpdate", {state: false});

                this.addLog({
                  message: `An admin has been deleted from the system, UID: ${docID}`,
                  level: "info"
                })
                this.getAdmins({
                  type: "success",
                  message:
                      "The user has successfully been deleted from the system.",
                  show: true
                });

                this.$store.dispatch("async/stateUpdate", {state: true});
              }
            })
            .catch(err => {
              // Show error message to the user for 5 sec
              this.$store.dispatch("alert/update", {
                type: "danger",
                message: err,
                show: true
              });
              this.addLog({
                message: err,
                level: "danger"
              })
              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", {show: false});
              }, 5000);
            });
				}
			},
      async getAdminShifts() {
        const ref = await db.collection("admin-shifts").get();
        if(ref.size) {
          ref.forEach(el => {
            this.allShifts.push({id: el.id, ...el.data()})
          })
        }
      },
		},
		mounted() {
			this.$store.dispatch("async/stateUpdate", {state: false});
      console.log(this.customers);
      this.getAdminShifts()
		},
		created() {
      this.loader = true;
			setTimeout(() => {
				this.getAdmins();
			}, 1500);
		},
		updated() {
			// const deleteuser = this.deleteUser
			// /* eslint-disable */
			// $("#datatable").on("click", ".remove", function () {
			// 	const docID = $(this).attr("data");
			// 	deleteuser(docID)
			// });
			/* eslint-enable */
		}
	};
</script>

<style>
	.refresh-user-link {
		position: absolute;
		top: 15px;
		right: 15px;
	}

	.refresh-storage-link {
		position: absolute;
		top: 15px;
		right: 215px;
	}

	.progress {
		margin-bottom: 10px;
	}
</style>
